import config from '../config';

export default class GtagEvents {

    static get events() {
        return {
            escape: {
                handle: 'escape',
                data: {
                    event_category: 'ui_actions',
                },
            },
            surveyStart: {
                handle: 'test_started'
            },
            surveyStartControl: {
                handle: 'control_test_started'
            },
            surveyComplete: {
                handle: 'test_completed'
            },
            surveyCompleteControl: {
                handle: 'control_test_completed'
            },
            surveyControlQuestionDuration: {
                handle: 'control_test_question_duration',
            },
            surveyDownload: {
                handle: 'download_test',
                data: {
                    event_category: 'results',
                },
            },
            surveySteps: {
                handle: 'steps',
                data: {
                    event_category: 'test_auto-evaluation',
                    event_label: 'current_step',
                },
            },
            startSurveyWithLSQ: {
                handle: 'test_start_lsq',
            },

            surveySpeakAssistant: {
                handle: 'speak_assistant',
            },
            surveyControlSpeakAssistant: {
                handle: 'control_speak_assistant',
            },
            startNewSurvey: {
                handle: 'test_start_next_survey'
            },
            startNewSurveyControl: {
                handle: 'control_test_start_next_survey'
            },

            // Unused
            startSurveyControlWithLSQ: {
                handle: 'control_test_start_lsq',
            },
        }
    }

    constructor() {
        console.log(`${this.constructor.name}:init`)
    }

    emit(event, args={}) {

        // Return if gtag is undefined
        if(!window.gtag) {
            return
        }

        // Get event properties
        event = GtagEvents.events[event]

        // Check if event is defined
        if(typeof event === 'undefined') {
            console.warn(`Gtag Event ${event} is undefined. Make sure the key is correct or add it GtagEvents instance events object if necessary`)
        } else {
            gtag('event', event.handle, {
                ...event.data,
                ...args
            })

            if(config.IS_DEV) {
                console.group(`${this.constructor.name}:emit`)
                console.log(event.handle, {
                    ...event.data,
                    ...args
                })
                console.groupEnd();
            }
        }
    }
}
